import type { StaticData } from '../entities/static-data';

import { data } from './data/static-data';

export function getMockedStaticData(siteId: string, _: Date): StaticData {
  const staticData = data[siteId];

  if (!staticData) {
    throw new Error('Empty Static Data');
  }

  return staticData;
}
